import React from 'react';
import * as RPopover from '@radix-ui/react-popover';
import { useExplainEntity } from '../../hooks/use-explain-entity';

export interface ExplainPopoverProps {
  pluginId: string;
  entityType: string;
  entityId: string;
  field: string;
  children: React.ReactNode; // the trigger (typically <ExplainIcon>)
}

export const ExplainPopover: React.FC<ExplainPopoverProps> = ({ pluginId, entityType, entityId, field, children }) => {
  const [open, setOpen] = React.useState(false);
  const query = useExplainEntity({ pluginId, entityType, entityId, field, enabled: open });

  return (
    <RPopover.Root open={open} onOpenChange={setOpen}>
      <RPopover.Trigger asChild>{children}</RPopover.Trigger>
      <RPopover.Portal>
        <RPopover.Content
          sideOffset={6}
          style={{
            background: 'white',
            border: '1px solid #e4e4e7',
            borderRadius: 6,
            padding: 10,
            maxWidth: 280,
            fontSize: 12,
            lineHeight: 1.5,
            boxShadow: '0 6px 16px rgba(0,0,0,0.08)',
            zIndex: 50,
          }}
        >
          {query.isLoading && <div role="status">Generating explanation…</div>}
          {query.error && <div role="alert" style={{ color: '#dc2626' }}>Could not load explanation.</div>}
          {query.data && (
            <>
              <div>{query.data.explanation}</div>
              <div style={{ marginTop: 6, fontSize: 10, color: '#71717a' }}>
                {query.data.cached ? 'Cached' : 'Fresh'}
                {' · '}
                <button
                  onClick={() => query.refetch()}
                  style={{ background: 'transparent', border: 'none', padding: 0, color: '#6366f1', cursor: 'pointer' }}
                >
                  Regenerate
                </button>
              </div>
            </>
          )}
        </RPopover.Content>
      </RPopover.Portal>
    </RPopover.Root>
  );
};
